import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=58d5feea&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d5feea')) {
      api.createRecord('58d5feea', component.options)
    } else {
      api.reload('58d5feea', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=58d5feea&", function () {
      api.rerender('58d5feea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2K89EFl6jvOKG/JS/videoIframe.vue"
export default component.exports